import { modalController } from '@ionic/vue'

export { modalController } 
import { createAnimation } from '@ionic/core';

export let currentlyOpened

export const enterAnimation = el => {
	const root = el.shadowRoot

	const backdropAnimation = createAnimation()
		.addElement(root.querySelector('ion-backdrop'))
		.fromTo('opacity', '0.01', 'var(--backdrop-opacity)')

	const wrapperAnimation = createAnimation()
		.addElement(root.querySelector('.modal-wrapper'))
		.keyframes([
			{ offset: 0, opacity: '0', transform: 'scale(0.88)' },
			{ offset: 1, opacity: '1', transform: 'scale(1)' },
		])

	return createAnimation().addElement(el).easing('ease-out').duration(100).addAnimation([backdropAnimation, wrapperAnimation])
}

export const leaveAnimation = el => enterAnimation(el).direction('reverse')

export async function open(component, componentProps, config?) {
	if (component == currentlyOpened)
		return { onDidDismiss: () => ({}) }
	
	const isPc = window.innerWidth >= 850 && window.innerHeight >= 600
	const modal = await modalController.create({
		component,
		initialBreakpoint: isPc ? undefined : 1,
		breakpoints: [0, 1],
		handle: true,
		...(isPc && { enterAnimation, leaveAnimation }),

		componentProps,
		...config
	})

	modal.onDidDismiss().then(() => currentlyOpened = null)
	
	modal.present()
	currentlyOpened = component
	return modal
}